<template>
    <div class="settings-field-partners">
        <div class="settings-field-partners__toolbar">
            <div class="settings-field-partners__toolbar-left">
                <el-button v-if="canManagePartners" type="primary" size="small" @click="openDialog()">+新增外勤</el-button>
            </div>
            <div class="settings-field-partners__toolbar-right">
                <el-input
                    v-model.trim="partnerSearchInput"
                    size="small"
                    clearable
                    placeholder="搜索姓名/手机/省份/对接专员"
                    class="settings-field-partners__search app-search-input"
                    @keyup.enter.native="applyPartnerSearch"
                >
                    <el-button slot="append" icon="el-icon-search" @click="applyPartnerSearch" />
                </el-input>
                <el-button size="small" @click="resetPartnerSearch">重置</el-button>
            </div>
        </div>
        <div class="settings-field-partners__table-wrap">
            <el-table
                v-loading="loading"
                :data="displayedPartners"
                border
                stripe
                size="small"
                class="settings-field-partners__table"
                fit
            >
                <el-table-column label="创建时间" min-width="154" align="center" header-align="center" show-overflow-tooltip>
                    <template slot-scope="{ row }">{{ formatPartnerCreatedAt(row) }}</template>
                </el-table-column>
                <el-table-column prop="name" label="姓名" min-width="72" align="center" header-align="center" show-overflow-tooltip />
                <el-table-column prop="phone" label="手机" min-width="118" align="center" header-align="center" show-overflow-tooltip />
                <el-table-column prop="province" label="主要服务省份" min-width="120" align="center" header-align="center" show-overflow-tooltip />
                <el-table-column label="对接专员" min-width="120" align="center" header-align="center" show-overflow-tooltip>
                    <template slot-scope="{ row }">{{ liaisonDisplay(row) }}</template>
                </el-table-column>
                <el-table-column label="状态" min-width="76" align="center" header-align="center">
                    <template slot-scope="{ row }">
                        <el-tag :type="Number(row.is_active) === 1 ? 'success' : 'info'" size="mini">
                            {{ Number(row.is_active) === 1 ? '启用' : '停用' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" min-width="100" align="center" header-align="center">
                    <template slot-scope="{ row }">
                        <template v-if="canManagePartners">
                            <el-button type="text" size="small" @click="openDialog(row)">编辑</el-button>
                            <el-button type="text" size="small" class="settings-field-partners__danger" @click="confirmRemove(row)">删除</el-button>
                        </template>
                        <span v-else>—</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div v-if="partnerListTotal > 0" class="settings-field-partners__pager">
            <el-pagination
                background
                layout="total, prev, pager, next, sizes"
                :page-sizes="[10, 20, 50, 100]"
                :current-page="partnerPage"
                :page-size="partnerPerPage"
                :total="partnerListTotal"
                @current-change="handlePartnerPageChange"
                @size-change="handlePartnerPageSizeChange"
            />
        </div>

        <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            width="520px"
            append-to-body
            @closed="resetForm"
        >
            <el-form ref="formRef" :model="form" :rules="rules" label-width="112px" size="small">
                <el-form-item label="姓名" prop="name">
                    <el-input v-model.trim="form.name" maxlength="64" show-word-limit placeholder="必填" />
                </el-form-item>
                <el-form-item label="手机" prop="phone">
                    <el-input v-model.trim="form.phone" maxlength="32" placeholder="选填" />
                </el-form-item>
                <el-form-item label="主要服务省份" prop="province">
                    <el-input v-model.trim="form.province" maxlength="64" placeholder="如：浙江省" />
                </el-form-item>
                <el-form-item label="对接专员" prop="liaison_user_id">
                    <el-select
                        v-model="form.liaison_user_id"
                        filterable
                        clearable
                        placeholder="选择子账号（可选）"
                        class="settings-field-partners__liaison-select"
                    >
                        <el-option
                            v-for="u in liaisonUserOptions"
                            :key="u.id"
                            :label="liaisonOptionLabel(u)"
                            :value="u.id"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="启用" prop="is_active">
                    <el-switch v-model="form.is_active" :active-value="1" :inactive-value="0" />
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'SettingsFieldPartners',
    data() {
        return {
            loading: false,
            partners: [],
            liaisonUserOptions: [],
            partnerSearchInput: '',
            partnerSearchApplied: '',
            dialogVisible: false,
            saving: false,
            editingId: null,
            form: {
                name: '',
                phone: '',
                province: '',
                liaison_user_id: null,
                is_active: 1
            },
            rules: {
                name: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
            },
            partnerPage: 1,
            partnerPerPage: 10
        };
    },
    computed: {
        canManagePartners() {
            var user = this.$store && this.$store.getters ? this.$store.getters.currentUser : null;
            var perms = user && user.permissions ? user.permissions : [];
            return perms.indexOf('field_partner.manage') >= 0 || perms.indexOf('order.edit') >= 0;
        },
        dialogTitle() {
            return this.editingId ? '编辑合作外勤' : '新增合作外勤';
        },
        filteredPartners() {
            var q = (this.partnerSearchApplied || '').toLowerCase();
            if (!q) {
                return this.partners;
            }
            return this.partners.filter(function (p) {
                var lu = p.liaison_user;
                var liaisonBlob = lu ? [lu.name, lu.username].join(' ') : '';
                var blob = [p.name, p.phone, p.province, liaisonBlob, String(p.id || '')].join(' ').toLowerCase();
                return blob.indexOf(q) >= 0;
            });
        },
        partnerListTotal() {
            return this.filteredPartners.length;
        },
        displayedPartners() {
            var list = this.filteredPartners;
            var start = (this.partnerPage - 1) * this.partnerPerPage;
            return list.slice(start, start + this.partnerPerPage);
        }
    },
    created() {
        this.fetchList();
        this.fetchLiaisonUsers();
    },
    methods: {
        liaisonDisplay: function (row) {
            if (!row || !row.liaison_user) {
                return '—';
            }
            var u = row.liaison_user;
            if (u.name) {
                return u.username ? String(u.name) + '（' + String(u.username) + '）' : String(u.name);
            }
            return u.username ? String(u.username) : '—';
        },
        liaisonOptionLabel: function (u) {
            if (!u) {
                return '';
            }
            if (u.name) {
                return u.username ? String(u.name) + '（' + String(u.username) + '）' : String(u.name);
            }
            return u.username ? String(u.username) : String(u.id);
        },
        fetchLiaisonUsers: function () {
            var _this = this;
            window.axios.get('/users').then(function (res) {
                _this.liaisonUserOptions = (res.data && res.data.data) || [];
            }).catch(function () {
                _this.liaisonUserOptions = [];
            });
        },
        formatPartnerCreatedAt: function (row) {
            if (!row || !row.created_at) {
                return '—';
            }
            var s = String(row.created_at);
            if (s.length >= 19) {
                return s.slice(0, 19).replace('T', ' ');
            }
            return s.length >= 10 ? s.slice(0, 10) : s;
        },
        clampPartnerPage: function () {
            var total = this.filteredPartners.length;
            var per = this.partnerPerPage || 10;
            var lastPage = Math.max(1, Math.ceil(total / per) || 1);
            if (this.partnerPage > lastPage) {
                this.partnerPage = lastPage;
            }
        },
        handlePartnerPageChange: function (p) {
            this.partnerPage = p;
        },
        handlePartnerPageSizeChange: function (size) {
            this.partnerPerPage = size;
            this.partnerPage = 1;
        },
        applyPartnerSearch: function () {
            this.partnerSearchApplied = (this.partnerSearchInput || '').trim();
            this.partnerPage = 1;
            this.$nextTick(this.clampPartnerPage);
        },
        resetPartnerSearch: function () {
            this.partnerSearchInput = '';
            this.partnerSearchApplied = '';
            this.partnerPage = 1;
            this.fetchList();
        },
        fetchList() {
            var _this = this;
            this.loading = true;
            window.axios.get('/field-partners').then(function (res) {
                _this.partners = res.data.data || [];
                _this.$nextTick(function () {
                    _this.clampPartnerPage();
                });
            }).catch(function () {
                _this.$message.error('加载失败');
            }).finally(function () {
                _this.loading = false;
            });
        },
        openDialog(row) {
            if (this.liaisonUserOptions.length === 0) {
                this.fetchLiaisonUsers();
            }
            if (row && row.id) {
                this.editingId = Number(row.id);
                this.form = {
                    name: row.name || '',
                    phone: row.phone || '',
                    province: row.province || '',
                    liaison_user_id: row.liaison_user && row.liaison_user.id != null
                        ? Number(row.liaison_user.id)
                        : (row.liaison_user_id != null && row.liaison_user_id !== '' ? Number(row.liaison_user_id) : null),
                    is_active: row.is_active != null ? Number(row.is_active) : 1
                };
            } else {
                this.editingId = null;
                this.resetForm();
            }
            this.dialogVisible = true;
        },
        resetForm() {
            this.form = {
                name: '',
                phone: '',
                province: '',
                liaison_user_id: null,
                is_active: 1
            };
            if (this.$refs.formRef) {
                this.$refs.formRef.clearValidate();
            }
        },
        submit() {
            var _this = this;
            this.$refs.formRef.validate(function (valid) {
                if (!valid) {
                    return;
                }
                _this.saving = true;
                var payload = {
                    name: _this.form.name,
                    phone: _this.form.phone || null,
                    province: _this.form.province || null,
                    liaison_user_id: _this.form.liaison_user_id != null && _this.form.liaison_user_id !== ''
                        ? Number(_this.form.liaison_user_id)
                        : null,
                    is_active: Number(_this.form.is_active) === 1 ? 1 : 0,
                    remark: null
                };
                var req;
                if (_this.editingId) {
                    req = window.axios.put('/field-partners/' + _this.editingId, payload);
                } else {
                    req = window.axios.post('/field-partners', payload);
                }
                req.then(function () {
                    _this.$message.success('保存成功');
                    _this.dialogVisible = false;
                    _this.partnerPage = 1;
                    _this.fetchList();
                }).catch(function (err) {
                    var msg = err && err.response && err.response.data && err.response.data.message
                        ? err.response.data.message
                        : '保存失败';
                    _this.$message.error(msg);
                }).finally(function () {
                    _this.saving = false;
                });
            });
        },
        confirmRemove(row) {
            var _this = this;
            if (!row || !row.id) {
                return;
            }
            this.$confirm('确定删除该合作外勤吗？已关联订单将清空外勤人选。', '删除确认', { type: 'warning' }).then(function () {
                return window.axios.delete('/field-partners/' + row.id);
            }).then(function () {
                _this.$message.success('已删除');
                _this.fetchList();
            }).catch(function (err) {
                if (err === 'cancel') {
                    return;
                }
                var msg = err && err.response && err.response.data && err.response.data.message
                    ? err.response.data.message
                    : '删除失败';
                _this.$message.error(msg);
            });
        }
    }
};
</script>

<style scoped>
.settings-field-partners {
    padding: 0;
}

.settings-field-partners__toolbar {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px 16px;
}

.settings-field-partners__toolbar-left,
.settings-field-partners__toolbar-right {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.settings-field-partners__toolbar-left > * {
    margin-bottom: 4px;
}

.settings-field-partners__toolbar-right > * {
    margin-bottom: 4px;
}

.settings-field-partners__search {
    width: 300px;
    max-width: 100%;
    min-width: 200px;
}

.settings-field-partners__liaison-select {
    width: 100%;
}

.settings-field-partners__table-wrap {
    width: 100%;
    overflow-x: auto;
}

/* 列宽随内容在 min-width 之上伸缩；整表不强行拉满时出现大块留白 */
.settings-field-partners__table {
    width: auto;
    max-width: 100%;
}

.settings-field-partners__table >>> .el-table__header-wrapper table,
.settings-field-partners__table >>> .el-table__body-wrapper table {
    table-layout: auto;
}

.settings-field-partners__pager {
    margin-top: 14px;
    text-align: right;
}

.settings-field-partners__danger {
    color: #f56c6c;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/SettingsFieldPartners.vue